import React, {useState} from 'react';
import '../../../css/scheduledCalls.css';
import { fetchWithDefaults } from '../../../config/fetchDefault';
import { useDispatch, useSelector } from 'react-redux';
import { fetchActivityThunk } from '../../../features/scheduledCallSlice';
import { formatTimestamp } from '../../../utilities/dashFunction';


function ScheduledAppointment({data, openLead, isMin, maxList}) {

    const agentInfo = useSelector((state) => state.agent.userData);
    const dispatch = useDispatch();

    // useEffect(() => {
    //     console.log("Updating newData:", data); // Debug log
    //     setData(data);
    // }, [data]);

    const [newData, setData] = useState(data);
    const cancel= async(apptId)=>{
        try {
            const requestOptions = {
                method: 'DELETE',
                body: JSON.stringify({
                    appointment: apptId,
                })
            };

            const response = await fetchWithDefaults(`/appointment/cancel`, requestOptions);

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            if(response.ok){
               dispatch(fetchActivityThunk({ agentIdNumber: agentInfo.agentId }));
            }
            const jsonData = await response.json();
            if(jsonData){
                // Remove the canceled call from the data prop
                const updatedTasksState = newData.map(dateGroup => ({
                    ...dateGroup,
                    tasks: dateGroup.tasks.filter(task => task.id !== apptId)
                }));
                setData(updatedTasksState);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    let totalItems=0;
    if(newData[0].type !== false){
        newData.map((item, index) => (
            totalItems=totalItems + item['tasks'].length
        ))
    }
    
    return (
        <div className="outerWrapper" style={{textAlign: 'center'}}>
            <span className="outerWrapperTitle"><span className="outerWrapperIcon"></span>Scheduled Appointments</span>
            <div className={`frontPageQuilityParentBlockWrapper ${isMin ? 'minimized' : ''}`} style={{width:'70%'}}>
                {isMin && <div className="circleTitle" onClick={() => maxList()}>Appts</div>}
                <div className="quilityParentBlockHeader">
                    <div className='quilityParentBlockTitle'>
                        Upcoming Appointments
                    </div>
                </div>
                <div className="quilityParentBlockContent">
                {data[0].type === false ? (
                        <div className="noresultBig">No Scheduled Appointments</div>
                    ) : (
                        <>
                    {newData.map((item, index) => (
                        <>
                        {item.tasks.map((call, index) => (
                            <div className="quilityNestedBlockWrapper " key={call.callId}>
                                <div class="quilityNestedBlockHeader">
                                    <div class="quilityParentBlockTitle">Meeting With {call.borrower_first} {call.borrower_last}</div>
                                </div>
                                <div className="infoWrapper">
                                    <div className="quilityDataLine">
                                        <span className="scheduledName">{call.borrower_first} {call.borrower_last}</span>
                                    </div>
                                    <div className="quilityDataLine">
                                        <span className="scheduledDate">{formatTimestamp(call.date)}</span>
                                    </div>

                                    <div className="quilityDataLine">
                                        <span className="scheduledLastContacted">
                                            {call.type === 'meet' ? (
                                                <span>Google Meet</span>
                                            ) : call.type === 'zoom' ? (
                                                <span>Zoom</span>
                                            ) : call.type === 'phone' ? (
                                                <span>Phone</span>
                                            ) : call.type === 'home' ? (
                                                <span>Home</span>
                                            ) : (
                                                <span>Unknown Type</span>
                                            )}
                                        </span>
                                    </div>
                                    {call.link && (
                                        <div className="quilityDataLine">
                                            <span className="scheduledCallType">{call.link}</span>
                                        </div>
                                    )}
                                </div>
                                <span className="schedulefunctionButtons" style={{marginBottom:'30px', marginTop:'20px'}}>
                                    <span className="wideBlockButton accentButton solidQuilityDestructiveButton" onClick={() => cancel(call.id)}>Cancel</span>
                                    <span className="wideBlockButton accentButton solidQuilityActiveButton" onClick={() => openLead(call.lead_id)}>View Lead</span>
                                </span>
                            </div>
                        ))}
                        </>
                    ))}
                    </>
                )}
                </div>
                <div className="blockFooter">
                    <div className="buttonWrapper" style={{marginTop:'5px', marginLeft:'10px'}}><div className="dataButtonBlock">Total: {totalItems}</div></div>
                </div>
            </div>

        </div>
    );
}

export default ScheduledAppointment;